<template>
  <!-- 费用报销 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <!-- <el-button class="glo_btnItems glo_bgcMainColor" @click="clickAdd(1)">运单费用报销</el-button> -->
        <el-button class="glo_btnItems glo_bgcMainColor" @click="clickAdd(8)"
          >运单应付费用报销</el-button
        >
        <el-button class="glo_btnItems glo_bgcMainColor" @click="clickAdd(4)"
          >外发费用报销</el-button
        >
        <el-button class="glo_btnItems glo_bgcMainColor" @click="clickAdd(5)"
          >发车费用报销</el-button
        >
        <el-button class="glo_btnItems glo_bgcMainColor" @click="clickAdd(3)"
          >日常费用报销</el-button
        >
        <el-button class="glo_btnItems glo_bgcMainColor" @click="clickAdd(2)"
          >车辆费用报销</el-button
        >
        <el-button class="glo_btnItems" @click="onClick(1)"
          >批量一级审核</el-button
        >
        <el-button class="glo_btnItems" @click="onClick(2)"
          >批量二级审核</el-button
        >
        <el-button class="glo_btnItems" @click="onClick(3)">批量过账</el-button>
        <el-button class="glo_btnItems" @click="onClick(4)"
          >批量反过账</el-button
        >
        <el-button class="glo_btnItems" @click="onClick(5)">批量删除</el-button>
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dayin">打印</el-dropdown-item>
            <!-- <el-dropdown-item command="dayinA"
              >打印-发车单报销明细单</el-dropdown-item
            >
            <el-dropdown-item command="dayinB"
              >打印-运单应付报销明细单</el-dropdown-item
            >
            <el-dropdown-item command="dayinC"
              >打印-外发单报销明细单</el-dropdown-item
            > -->
            <el-dropdown-item command="jtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <!-- 时间组件 -->
        <el-form-item class="queryItemsTimes">
          <multitime
            :timeType="timeType"
            :timeTypes="timeTypes"
            :startTime="startTime_a"
            :endTime="endTime_a"
            @timestatus="timestatus"
            @queryBtn_ok="queryBtn_time"
          ></multitime>
        </el-form-item>
        <el-form-item class="queryItems" label="报销单号:">
          <el-input
            clearable
            v-model="queryData.number"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item style="width: 470px" class="queryItems" label="结算对象:">
          <div class="multipleSelect">
            <el-select
              filterable
              clearable
              v-model="objectStatusType"
              placeholder="请选择"
              @change="changeObjestStatusYS"
            >
              <el-option
                v-for="item in objectStatusList"
                :key="item.key"
                :label="item.val"
                :value="item.key"
              ></el-option>
            </el-select>
            <el-select
              filterable
              clearable
              v-model="queryData.objectName"
              placeholder="请选择"
              remote
              :allow-create="objectStatusType == 'other'"
              :remote-method="getObjectUserDownListYf"
              @change="changeobjectName"
            >
              <el-option
                v-for="(item, index) in CustomerListsYF"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item style="width: 470px" class="queryItems" label="费项:">
          <div class="multipleSelect">
            <el-select
              filterable
              clearable
              v-model="queryData.itemCategoryId"
              placeholder="请选择"
              @change="changeItemCategoryId"
            >
              <el-option
                v-for="item in categoryNameList"
                :key="item.categoryId"
                :label="item.categoryName"
                :value="item.categoryId"
              ></el-option>
            </el-select>
            <el-select
              filterable
              clearable
              v-model="queryData.itemServiceId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in CategoryServiceList"
                :key="item.itemServiceId"
                :label="item.title"
                :value="item.itemServiceId + ''"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="业务网点:" class="queryItems">
          <el-select v-model="queryData.businessDeptId" placeholder="请选择">
            <el-option
              v-for="(item, index) in businessDeptIdArr"
              :key="index"
              :label="item.departmentName"
              :value="item.deptId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="过账状态:" class="queryItems">
          <el-select
            filterable
            clearable
            v-model="queryData.isPosting"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in isPostingList"
              :key="index"
              :label="item.name"
              :value="item.val"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="核销状态:" class="queryItems">
          <el-select
            filterable
            clearable
            v-model="queryData.isSettlement"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in isSettlementList"
              :key="index"
              :label="item.name"
              :value="item.val"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付款方式:" class="queryItems">
          <el-select
            filterable
            clearable
            v-model="queryData.settlementMethodConfDictId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in settlementMethodList"
              :key="item.confDictId"
              :label="item.val"
              :value="item.confDictId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报销类型:" class="queryItems">
          <el-select
            filterable
            clearable
            v-model="queryData.reimbursementDirection"
            placeholder="请选择"
            @visible-change="getreimbursementDirectionList"
          >
            <el-option
              v-for="item in reimbursementDirectionList"
              :key="item.statusValue"
              :label="item.showName"
              :value="item.statusValue"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            v-if="item && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            align="center"
            sortable
            :show-overflow-tooltip="true"
          ></el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="220px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="clickAdd(6, scope.row)"
                >修改</el-button
              >
              <el-button class="rbtns" @click.stop="clickAdd(7, scope.row)"
                >详情</el-button
              >
              <el-button class="rbtns" @click.stop="onClick(3, scope.row)"
                >过账</el-button
              >
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">一级审核</el-dropdown-item>
                  <el-dropdown-item command="b">二级审核</el-dropdown-item>
                  <el-dropdown-item command="c">整单核销</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 整单核销 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      :isAppend="true"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn"
    >
      <div class="formbox" v-if="isShowDialog">
        <el-form class="glo_formBox" label-width="120px">
          <el-form-item class="dialogTims" label="核销金额:">
            <el-input
              v-model="dialogFormsettlementAmount"
              disabled
              placeholder="自动生成"
            ></el-input>
          </el-form-item>
          <el-form-item class="dialogTims" label="核销资金账号:">
            <el-select
              filterable
              clearable
              v-model="dialogForm.accountId"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in fundAccountList"
                :key="index"
                :label="item.account"
                :value="item.assetaccountId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogTims" label="核销时间:">
            <el-date-picker
              class="input"
              v-model="dialogForm.writeOffTime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item class="textArea" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.writeoffComment"
            ></el-input>
          </el-form-item>
          <div class="uploadBox">
            <div class="uploadLaber">图片:</div>
            <div class="uploadItem">
              <uploadimgs
                @input="changeFileList_zh"
                :fileNameLists="fileNameLists1"
                :limit="9"
              ></uploadimgs>
            </div>
          </div>
          <el-form-item class="dialogTims" label="操作时间:">
            <el-input disabled placeholder="自动生成"></el-input>
          </el-form-item>
          <el-form-item class="dialogTims" label="操作人:">
            <el-input disabled placeholder="自动生成"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 当前页面的查询条件 -->
      <div ref="queryForm">
        <el-form
          :model="queryData"
          class="glo_form hasMoreParam"
          label-position="left"
        >
          <!-- 时间组件 -->
          <el-form-item class="queryItemsTimes">
            <multitime
              :timeType="timeType"
              :timeTypes="timeTypes"
              :startTime="startTime_a"
              :endTime="endTime_a"
              @timestatus="timestatus"
              @queryBtn_ok="queryBtn_time"
            ></multitime>
          </el-form-item>
          <el-form-item
            style="width: 470px"
            class="queryItems"
            label="结算对象:"
          >
            <div class="multipleSelect">
              <el-select
                filterable
                clearable
                v-model="objectStatusType"
                placeholder="请选择"
                @change="changeObjestStatusYS"
              >
                <el-option
                  v-for="item in objectStatusList"
                  :key="item.key"
                  :label="item.val"
                  :value="item.key"
                ></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                v-model="queryData.objectName"
                placeholder="请选择"
                remote
                :allow-create="objectStatusType == 'other'"
                :remote-method="getObjectUserDownListYf"
                @change="changeobjectName"
              >
                <el-option
                  v-for="(item, index) in CustomerListsYF"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item style="width: 470px" class="queryItems" label="费项:">
            <div class="multipleSelect">
              <el-select
                filterable
                clearable
                v-model="queryData.itemCategoryId"
                placeholder="请选择"
                @change="changeItemCategoryId"
              >
                <el-option
                  v-for="item in categoryNameList"
                  :key="item.categoryId"
                  :label="item.categoryName"
                  :value="item.categoryId"
                ></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                v-model="queryData.itemServiceId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in CategoryServiceList"
                  :key="item.itemServiceId"
                  :label="item.title"
                  :value="item.itemServiceId + ''"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="业务网点:" class="queryItems">
            <el-select v-model="queryData.businessDeptId" placeholder="请选择">
              <el-option
                v-for="(item, index) in businessDeptIdArr"
                :key="index"
                :label="item.departmentName"
                :value="item.deptId"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="过账状态:" class="queryItems">
            <el-select
              filterable
              clearable
              v-model="queryData.isPosting"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in isPostingList"
                :key="index"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="核销状态:" class="queryItems">
            <el-select
              filterable
              clearable
              v-model="queryData.isSettlement"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in isSettlementList"
                :key="index"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款方式:" class="queryItems">
            <el-select
              filterable
              clearable
              v-model="queryData.settlementMethodConfDictId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in settlementMethodList"
                :key="item.confDictId"
                :label="item.val"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报销类型:" class="queryItems">
            <el-select
              filterable
              clearable
              v-model="queryData.reimbursementDirection"
              placeholder="请选择"
              @visible-change="getreimbursementDirectionList"
            >
              <el-option
                v-for="item in reimbursementDirectionList"
                :key="item.confDictId"
                :label="item.val"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </exportCompoent>

    <!-- 打印 -->
    <div>
      <prints
        :diaWidth_print="diaWidth_print"
        :dialogTitle_print="dialogTitle_print"
        :isShowDialog_print="isShowDialog_print"
        :dataList="dataList"
        :topData="topData"
        @handleCloseDia_print="handleCloseDia_print"
        @diaConfirmBtn_print="diaConfirmBtn_print"
      ></prints>

      <!-- 选择打印模板 -->
      <printDialog
        :dialogFrom="dialogFrom"
        ref="dialogSelect"
        title="选择模板"
        icon="el-icon-printer"
        :modelTypeVal="modelTypeVal"
        @handleCreated="handleCreated"
        @handleView="handleView"
        @handleEdit="handleEdit"
        @handleOk="handleView"
      >
      </printDialog>

      <!-- 创建和使用模板 -->

      <printSys
        :printForm="printForm"
        :title="printTitle"
        icon="el-icon-printer"
        @handleClose="handlePrintSysClose"
      >
        <printSysContent
          :printType="printType"
          :modelObj="modelObj"
          :modelClassName="modelClassName"
          :selectTableData="selectTableData"
        ></printSysContent>
      </printSys>

      <!-- 打印系统数据接口的className -->

      <classNameDialog
        :diaWidth="classNameDiaWidth"
        :dialogTitle="classNameDialogTitle"
        :isShowDialog="isShowClassNameDialog"
        @handleCloseDia="handleCloseClassNameDia"
        @diaCancelBtn="classNameDiaCancelBtn"
        @diaConfirmBtn="classNameDiaConfirmBtn"
      >
        <el-select v-model="modelClassName" placeholder="" style="width: 100%">
          <el-option
            v-for="(value, key) in classNameArr"
            :key="key"
            :label="value.name"
            :value="value.val"
          >
          </el-option>
        </el-select>
      </classNameDialog>
    </div>
  </div>
</template>
<script>
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import multitime from "@/components/multiTime.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import addCustomerTarck from "@/components/CustomerServiceTrackingNew.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js

import { mixin_print } from "@/assets/js/Mixins/mixinPrint";

export default {
  mixins: [exportjs, mixin_print],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    multitime,
    addCustomerTarck,
    myDialog,
    uploadimgs,
    queryBtns,
  },
  data() {
    return {
      objectStatusType: "",
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "费用报销列表", //导出时默认文件名
        apiName: "/admin/v4/finance/expense/getExpenseList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      isShowDialog: false,
      dialogTitle: "整单核销",
      diaWidth: "60%",
      dialogForm: {
        accountId: "",
        financeId: "",
        writeOffPics: "",
        writeOffTime: "",
        writeoffComment: "",
      },
      fileNameLists1: [],
      fundAccountList: [],

      //  -----  查询  ------
      queryData: {
        businessDeptId: "",
        endCreateTime: "",
        endTaskCreateTime: "",
        isPosting: "",
        isSettlement: "",
        itemCategoryId: "",
        itemServiceId: "",
        objectName: "",
        objectStatusConfDictId: "",
        settlementMethodConfDictId: "",
        startCreateTime: "",
        startOccurrenceTime: "",
        reimbursementDirection: "",
      }, //  表单查询数据
      isPostingList: [
        //过账状态
        { val: 0, name: "未过账" },
        { val: 1, name: "已过账" },
      ],
      isSettlementList: [
        //核销状态
        { val: 0, name: "未核销" },
        { val: 1, name: "已核销" },
      ],
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "创建日期",
        },
        {
          value: "1",
          label: "发生日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",

      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据

      show_sortTableHeard: false, //显示表格设置弹窗
      // 默认表头
      tabelHeadeTitle: [
        {
          name: "报销类型",
          field: "reimbursementDirectionShow",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "报销单号",
          field: "number",
          width: "220",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "报销网点",
          field: "businessDeptName",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "申请日期",
          field: "occurrenceTime",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "结算对象类型",
          field: "objectStatus",
          width: "200",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "结算对象",
          field: "objectName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "费项类型",
          field: "itemCategoryName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "费项",
          field: "itemServiceName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发生金额",
          field: "amount",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "付款方式",
          field: "settlementMethod",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "核销方式",
          field: "writeoffMethodShow",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "借支账号",
          field: "zjAccount",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "借支核销金额",
          field: "settlementAmount",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "关联运单",
          field: "isRelationWaybill",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "关联运单数",
          field: "relationWaybillCount",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "关联车辆",
          field: "carNumber",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "关联车辆数",
          field: "relationCarCount",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "备注",
          field: "remark",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "过账状态",
          field: "isPostingShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "过账人",
          field: "postingUserName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "过账时间",
          field: "postingTime",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "审核状态",
          field: "approveStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "审核人",
          field: "approverUserName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "审核时间",
          field: "approveTime",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "核销人",
          field: "writeoffUserName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "核销状态",
          field: "isSettlementShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "核销时间",
          field: "writeoffTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "资金账号",
          field: "zjAccount",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "核销备注",
          field: "writeoffComment",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "一级审核状态",
          field: "oneApproveStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "一级审核时间",
          field: "oneApproveTime",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "一级审核人",
          field: "oneApproveUserName",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "二级审核状态",
          field: "twoApproveStatusShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "二级审核时间",
          field: "twoApproveTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "二级审核人",
          field: "twoApproveUserName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      myTableHeard: [], //  我的表头

      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      tableData: [], //  表格数据

      allCheck: false, //  全选
      sortName: "综合查询模板", //  排序名
      selectLength: 0, //  显示的长度

      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "FinancialManagement_ExpenseReimbursement", //  页面标识

      businessDeptIdArr: [],
      objectStatusList: [],
      settlementMethodList: [],
      reimbursementDirectionList: [],
      categoryNameList: [],
      CategoryServiceList: [],
      CustomerListsYF: [],

      // ================打印插件================
      // 模板className 问后台拿
      idarrs: [],
      modelTypeVal: "费用报销模块",
      classNameArr: [
        {
          name: "费用报销单",
          val: "com.bami.service.tms.v3.admin.print.vo.AdminExpensePrintDataV4tmsVo",
        },
        {
          name: "发车单报销明细单",
          val: "com.bami.service.tms.v3.admin.print.vo.AdminExpenseDispatchPrintDataPackV4tmsVo",
        },
        {
          name: "运单应付报销明细单",
          val: "com.bami.service.tms.v3.admin.print.vo.AdminExpenseWaybillFinanceOutPackPrintDataV4tmsVo",
        },
        {
          name: "外发单报销明细单",
          val: "com.bami.service.tms.v3.admin.print.vo.AdminExpenseOutgoingPrintPackDataV4tmsVo",
        },
        {
          name: "请选择",
          val: "",
        },
      ], // 默认的模板类型
      modelClassName: "",
      // ================打印插件================
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle;
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;;
    this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
    this.GetDept();
    this.itemCategorChoose(); //费型类型下拉列表
    this.getConfDictValDownList("object_status");
    this.getConfDictValDownList("settlement_method");
    // this.GetassetaccountList();

    this.getData();
  },
  activated() {
    // 每次进页面都会触发的写这里
    //计算获取表格高度
    //获取默认表头
  },
  mounted() {
    this.$nextTick(() => {
      this.fetTableHeight();
    });
  },
  watch: {},
  methods: {
    getreimbursementDirectionList(e) {
      console.log(e);
      // e==true   显示下拉
      if (e) {
        // 报销类型下拉列表
        this.$API
          .runPageReportDetails({
            number: "dict_status_show",
            conditionReqs: [
              {
                conditonKey: "tableAndFieldName",
                conditonVal:
                  "bill_finance_other_out_v3.reimbursement_direction",
              },
            ],
          })
          .then((res) => {
            let datas = res.data.result.datas || [];
            console.log(datas, "datas");
            this.reimbursementDirectionList = datas;
          });
      }
    },

    // ==================打印插件==================
    // 打印按钮
    printEvent(val) {
      let idarr = [];
      if (val) {
        idarr.push(val.otherId);
        this.selectTableData = [val];
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请选择需要打印的数据");
          return false;
        }
        idarr = this.selectTableData.map((item) => {
          return item.otherId;
        });
      }
      this.idarrs = idarr;

      window.sessionStorage.setItem(
        "set_PrintSelectTableData",
        JSON.stringify(idarr)
      );
      this.dialogFrom.dialogVisible = true;
    }, // 打印预览模板
    handleView(obj) {
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      });
      let idarr = this.idarrs || []; // for (let i = 0; i < this.selectTableData.length; i++) { //   idarr.push(this.selectTableData[i].otherId); // }
      if (obj.className == this.classNameArr[0].val) {
        // 获取打印数据  费用报销单
        this.$API
          .getExpensePrintData({
            expenseIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      } else if (obj.className == this.classNameArr[1].val) {
        // 获取打印数据  发车单报销明细单
        this.$API
          .getExpenseDispatchPrintData({
            expenseIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      } else if (obj.className == this.classNameArr[2].val) {
        // 获取打印数据  运单应付报销明细单
        this.$API
          .getExpenseWaybillFinanceOutPrintData({
            expenseIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      } else if (obj.className == this.classNameArr[3].val) {
        // 获取打印数据  外发单报销明细单
        this.$API
          .getExpenseOutgoingPrintData({
            expenseIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      }
    },
    // 打印-确定模板的数据
    handleOk(obj) {
      // let hiprintTemplate = new hiprint.PrintTemplate({
      //   template: JSON.parse(obj.content),
      // });
      // let idarr = this.idarrs || []; // for (let i = 0; i < this.selectTableData.length; i++) { //   idarr.push(this.selectTableData[i].otherId); // }
      // if (obj.className == this.classNameArr[0].val) {
      //   this.$API
      //     .getExpensePrintData({
      //       expenseIds: idarr,
      //     })
      //     .then((res) => {
      //       if (res.status == 200) {
      //         if (res.data && res.data.status == "success") {
      //           const result = res.data.result;
      //           hiprintTemplate.print(result, {});
      //         }
      //       }
      //     });
      // }
    }, // ==================打印插件==================

    // 获取资金账号列表
    GetassetaccountList() {
      // this.$API.assetaccountList().then((res) => {
      //   if (res.data.status === "success") {
      //     let result = res.data.result?.data || [];
      //     this.fundAccountList = result;
      //   } else {
      //     this.$message.error(`${res.data.message}`);
      //   }
      // });
      
      this.$API
        .runPageReportDetails({
          number: "down_list_jie_zhi_assetaccount",
        })
        .then((res) => {
          this.fundAccountList = res.data.result.datas.data || [];
        });
    },
    // 选择图片(装货确认)
    changeFileList_zh(array) {
      this.fileNameLists1 = array;
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.dialogForm = {
        accountId: "",
        financeId: "",
        writeOffPics: "",
        writeOffTime: "",
        writeoffComment: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.dialogForm.writeOffPics = this.fileNameLists1.map((item) => {
        return item.name;
      });
      this.$API.writeOffExpense(this.dialogForm).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.getData();
        this.isShowDialog = false;
      });
    },
    handleCommandBtns(key, row) {
      switch (key) {
        case "a":
          // 批量一级审核
          this.$confirm("确定要批量一级审核所选数据吗? 请谨慎操作", "提示:")
            .then((res) => {
              this.$API
                .oneApprove({
                  otherIds: [row.otherId],
                })
                .then((res) => {
                  this.$message.success(res.data.message || "操作成功");
                  this.getData();
                });
            })
            .catch((err) => {});
          break;
        case "b":
          // 批量二级审核
          this.$confirm("确定要二级审核所选数据吗? 请谨慎操作", "提示:")
            .then((res) => {
              this.$API
                .twoApprove({
                  otherIds: [row.otherId],
                })
                .then((res) => {
                  this.$message.success(res.data.message || "操作成功");
                  this.getData();
                });
            })
            .catch((err) => {});
          break;
        case "c":
          // 报销单还未过账,请选过账
          let { financeId, amount } = row;
          if (financeId) {
            this.isShowDialog = true;
            this.dialogForm.financeId = row.financeId || "";
            this.dialogFormsettlementAmount = row.amount || 0;

            this.GetassetaccountList();
          } else {
            this.$message.error("报销单还未过账,请选过账");
          }
          break;
        default:
          break;
      }
    },
    onClick(key, row) {
      if (!this.selectTableData.length && !row) {
        this.$message.warning("请选择需要操作的任务");
        return false;
      }
      switch (key) {
        case 1:
          // 批量一级审核
          this.$confirm("确定要批量一级审核所选数据吗? 请谨慎操作", "提示:")
            .then((res) => {
              this.$API
                .oneApprove({
                  otherIds: this.selectTableData.map((n) => {
                    return n.otherId;
                  }),
                })
                .then((res) => {
                  this.$message.success(res.data.message || "操作成功");
                  this.getData();
                });
            })
            .catch((err) => {});
          break;
        case 2:
          // 批量二级审核
          this.$confirm("确定要二级审核所选数据吗? 请谨慎操作", "提示:")
            .then((res) => {
              this.$API
                .twoApprove({
                  otherIds: this.selectTableData.map((n) => {
                    return n.otherId;
                  }),
                })
                .then((res) => {
                  this.$message.success(res.data.message || "操作成功");
                  this.getData();
                });
            })
            .catch((err) => {});
          break;
        case 3:
          let otherIds = [];
          if (row) {
            otherIds = [row.otherId];
          } else {
            otherIds = this.selectTableData.map((n) => {
              return n.otherId;
            });
          }
          // 批量过账
          this.$confirm("确定要过账所选数据吗? 请谨慎操作", "提示:")
            .then((res) => {
              this.$API
                .batchPostin({
                  otherIds,
                })
                .then((res) => {
                  this.$message.success(res.data.message || "操作成功");
                  this.getData();
                });
            })
            .catch((err) => {});
          break;
        case 4:
          // 批量反过账
          this.$confirm("确定要反过账所选数据吗? 请谨慎操作", "提示:")
            .then((res) => {
              this.$API
                .rebatchPostin({
                  otherIds: this.selectTableData.map((n) => {
                    return n.otherId;
                  }),
                })
                .then((res) => {
                  this.$message.success(res.data.message || "操作成功");
                  this.getData();
                });
            })
            .catch((err) => {});
          break;
        case 5:
          // 批量删除
          this.$confirm("确定要删除所选数据吗? 请谨慎操作", "提示:")
            .then((res) => {
              this.$API
                .delExpense({
                  otherIds: this.selectTableData.map((n) => {
                    return n.otherId;
                  }),
                })
                .then((res) => {
                  this.$message.success(res.data.message || "操作成功");
                  this.getData();
                });
            })
            .catch((err) => {});
          break;
        default:
          break;
      }
    },
    clickAdd(key, row) {
      //  费用报销
      let query = {};
      if (row) {
        // 6 7
        query = {
          keyJumpt: key,
          otherId: row.otherId,
          reimbursementDirection: row.reimbursementDirection || "",
        };
      } else {
        const reimbursementDirection = {
          1: "bill_tms_waybill_split_v3:reimbursement_direction",
          2: "car_v3:reimbursement_direction",
          3: "ri_chang:reimbursement_direction",
          4: "bill_tms_waybill_outgoing_v3:reimbursement_direction",
          5: "bill_tms_dispatch_v3:reimbursement_direction",
          8: "bill_tms_waybill_v3_finance_out_service:reimbursement_direction",
        };
        query = {
          keyJumpt: 123456,
          reimbursementDirection: reimbursementDirection[key],
          pageType: "newPage", //表示进去要打开新页面,清除之前的缓存
        };
      }
      this.$router.push({
        path: "/FinancialManagement/ExpenseReimbursement/NewModificationDetails",
        query,
      });
    },
    // 选择结算对象类型(
    changeObjestStatusYS(e) {
      this.queryData.objectName = "";
      if (e) {
        this.objectStatusList.forEach((item) => {
          if (item.key == e) {
            this.queryData.objectStatusConfDictId = item.confDictId;
          }
        });
        this.getObjectUserDownListYf();
      } else {
        this.queryData.objectName = "";
      }
    },
    changeobjectName(e) {
      if (!e) {
        this.getObjectUserDownListYf();
      }
    },
    // (应付弹窗)根据对象类型获取对象的下拉列表
    getObjectUserDownListYf(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: this.objectStatusType || "",
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerListsYF = res.data.result.data || [];
        });
    },
    // 费型类型下拉列表
    itemCategorChoose(categoryName) {
      this.$API
        .itemCategorChoose({ categoryName: categoryName })
        .then((res) => {
          this.categoryNameList = res.data.result || [];
        });
    },
    //选择费项类型()
    changeItemCategoryId(e) {
      if (e) {
        this.wtl_itemServiceListAll(e);
      } else {
        this.queryData.itemServiceId = "";
      }
    },
    // 根据类别和费项类型获取费项
    wtl_itemServiceListAll(e, directionStatus) {
      this.$API
        .wtl_getCategoryServiceList({
          categoryId: e || "",
          directionStatus: directionStatus || "",
        })
        .then((res) => {
          this.CategoryServiceList = res.data.result || [];
        });
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(dictType) {
      this.$API
        .wtl_getConfDictValDownList({ dictType: dictType })
        .then((res) => {
          let arrs = res.data.result || [];
          if (dictType == "object_status") {
            // 获取结算对象类型
            this.objectStatusList = arrs || [];
          }
          if (dictType == "settlement_method") {
            // 获取付款方式
            this.settlementMethodList = arrs;
          }
        });
    },
    // 获取业务网点（组织架构列表）
    GetDept() {
      this.$API.wtl_getDeptList().then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          this.businessDeptIdArr = result;
        }
      });
    },
    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || "0";
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },

    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },

    getData() {
      this.queryData.startOccurrenceTime = ""; //发生时间 开始
      this.queryData.endOccurrenceTime = ""; //发生时间 结束
      this.queryData.startCreateTime = ""; //创建时间 开始
      this.queryData.endCreateTime = ""; //创建时间 结束
      if (this.timeType == 0) {
        // 0==创建时间
        this.queryData.startCreateTime = this.startTime_a
          ? this.startTime_a + " 00:00:00"
          : "";
        this.queryData.endCreateTime = this.endTime_a
          ? this.endTime_a + " 23:59:59"
          : "";
      } else {
        //发生时间
        this.queryData.startOccurrenceTime = this.startTime_a
          ? this.startTime_a + " 00:00:00"
          : "";
        this.queryData.endOccurrenceTime = this.endTime_a
          ? this.endTime_a + " 23:59:59"
          : "";
      }
      let param = {
        ...this.queryData,
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
      };
      this.$API.getExpenseList(param).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.fetTableHeight();
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },

    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },
    clerBtns() {
      //  重置按钮
      this.queryData = {
        businessDeptId: "",
        endCreateTime: "",
        endTaskCreateTime: "",
        isPosting: "",
        isSettlement: "",
        itemCategoryId: "",
        itemServiceId: "",
        objectName: "",
        objectStatusConfDictId: "",
        settlementMethodConfDictId: "",
        startCreateTime: "",
        startOccurrenceTime: "",
      };
      this.timeType = "0";
      this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum);
      this.endTime_a = this.$TOOLS.getCurrentDate();
      this.pageStart = 1;
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    handleSizeChange(val) {
      //  分页
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val;
      this.getData();
    },
    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight || 0; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },

    /****
     *  ===================下面页面公共方法 start ===================
     *
     */

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dayin") {
        // 打印
        this.printEvent();
      }

      if (a === "dr") {
        // 导入
      }
      if (a === "jtdc") {
        // 导出
        // this.exportBtn();
        this.isShowDialog_dc = true;
      }
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },
    //    -------------  设置列表表头方法  ------------
    // ==========排序表头的组件方法==========
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    /****
     *  ===================上面页面公共方法 end ===================
     *
     */
  },
};
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}

.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}

.mainCOlorBtns :hover {
  color: #fff;
}
.multipleSelect {
  width: 370px;
  display: flex;

  /deep/ .el-select {
    flex: 1;
  }
}
.textArea {
  width: 100%;
  height: auto !important;
}
.uploadBox {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .uploadLaber {
    margin-right: 10px;
  }
  .uploadItem {
    flex: 1;
  }
}
</style>
